interface InventoryFiltersProps {
  selectedSize: string;
  selectedStatus: string;
  onSizeChange: (size: string) => void;
  onStatusChange: (status: string) => void;
  availableSizes: string[];
}

const statuses = [
  { value: '', label: 'All' },
  { value: 'available', label: 'Available' },
  { value: 'reserved', label: 'Reserved' },
  { value: 'preorder_only', label: 'Preorder Only' },
  { value: 'sold', label: 'Sold' },
];

export function InventoryFilters({
  selectedSize,
  selectedStatus,
  onSizeChange,
  onStatusChange,
  availableSizes,
}: InventoryFiltersProps) {
  return (
    <div className="flex flex-wrap gap-4 items-center">
      <div className="flex items-center gap-2">
        <label htmlFor="size-filter" className="text-sm font-medium text-[var(--color-brand-muted)]">
          Size:
        </label>
        <select
          id="size-filter"
          value={selectedSize}
          onChange={(e) => onSizeChange(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm bg-white"
        >
          <option value="">All Sizes</option>
          {availableSizes.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <label htmlFor="status-filter" className="text-sm font-medium text-[var(--color-brand-muted)]">
          Status:
        </label>
        <select
          id="status-filter"
          value={selectedStatus}
          onChange={(e) => onStatusChange(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm bg-white"
        >
          {statuses.map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
